import React, { FC } from 'react';
import styles from '#modules/profileSelection/avatarlist/AvatarItem.module.scss';
import classNames from 'classnames';
import { avatarSource } from '#config';

type Props = {
  id: number;
  avatarAssetId: number;
  radioGroupName?: string;
  selected: boolean;
  onKeyPress?: (e) => void;
  onSelect: (id: number) => void;
};

const AvatarItem: FC<Props> = ({
  avatarAssetId,
  radioGroupName = 'avatar-list',
  selected,
  onKeyPress,
  onSelect,
}) => {
  const avatarImage = avatarSource(avatarAssetId, '256w');
  const blockClass = classNames(styles.host);

  const handleChange = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value: string = event.target.value as string;
    onSelect?.(parseInt(value, 10));
  };

  return (
    <li className={styles.host}>
      <label className={blockClass}>
        <input
          type="radio"
          className={styles.input}
          name={radioGroupName}
          checked={selected}
          value={avatarAssetId}
          onChange={handleChange}
          onKeyPress={onKeyPress}
        />
        <span className={styles.media}>
          {avatarImage && (
            <img className={styles.mediaInner} alt="" src={avatarImage} />
          )}
        </span>
      </label>
    </li>
  );
};

export default AvatarItem;
